import { api } from "@/lib/axios";
import type { ApiResponse } from "@/features/company/types/company.types";
import type { MonthRange, SmsMonthlyBilling } from "../types/smsBilling.types";

export const getSmsMonthlyBilling = async (
  range: MonthRange,
  signal?: AbortSignal,
): Promise<SmsMonthlyBilling> => {
  const { data } = await api.get<ApiResponse<SmsMonthlyBilling | null>>(
    "/api/Sms/Admin/Monthly-Billing",
    {
      params: { fromMonth: range.fromMonth, toMonth: range.toMonth },
      signal,
      // 원본 로그 테이블 집계라 기본 30초로는 모자랄 수 있다
      timeout: 120000,
    },
  );
  if (data.code !== 200 || !data.result) throw new Error(data.message);
  return data.result;
};
